import React, { Fragment, Component } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { scroller, Element } from "react-scroll";
import Gallery from "react-photo-gallery";

import img1 from "./photos/c.png";
import img2 from "./photos/Ciderama_outside3small.png";
import img3 from "./photos/crowd_bannerssmallerpng.png";
import img4 from "./photos/girls._taking_photo.png";
import img5 from "./photos/HANDING OVER DRINK.png";
import img6 from "./photos/Roberto_talkandtastings2.png";

//App Specific Components
import BackgroundLayer from "./components/BackgroundLayer";
import ForegroundLayer from "./components/ForegroundLayer";
import Header from "./components/Header";
import VideoSection from "./components/VideoSection";
import CideriesSection from "./components/CideriesSection";
import StreetFoodSection from "./components/StreetFoodSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

//Global Style
import GlobalStyle from "./styles/GlobalStyle";

class Ciderama extends Component {
  scrollToCideriesSection = () => {
    scroller.scrollTo("cideries", {
      duration: 1000,
      delay: 100,
      smooth: true
    });
  };

  scrollToStreetFoodSection = () => {
    scroller.scrollTo("streetFood", {
      duration: 1000,
      delay: 100,
      smooth: true
    });
  };

  scrollToFAQSection = () => {
    scroller.scrollTo("faqs", {
      duration: 1000,
      delay: 100,
      smooth: true
    });
  };

  render() {
    const photos = [
      {
        src: img1,
        width: 1,
        height: 1
      },
      {
        src: img2,
        width: 1,
        height: 1
      },
      {
        src: img3,
        width: 1,
        height: 1
      },
      {
        src: img4,
        width: 1,
        height: 1
      },
      {
        src: img5,
        width: 1,
        height: 1
      },
      {
        src: img6,
        width: 1,
        height: 1
      }
    ];
    const BasicRows = () => <Gallery photos={photos} />;
    return (
      <Fragment>
        <GlobalStyle />
        <Header />
        <Container>
          <Row style={{ marginBottom: "100px" }}>
            <Col />
            <Col md={8}>
              <VideoSection findOutMoreOnClick={this.scrollToCideriesSection} />
              <Element name="cideries" />
              <CideriesSection />
              <Element name="streetFood" />
              <StreetFoodSection />
            </Col>
            <Col />
          </Row>
          <BasicRows />
        </Container>
        <Container style={{ marginTop: "100px" }} fluid>
          <Element name="faqs" />
          <FAQSection />
        </Container>
        <Footer />
        <BackgroundLayer />
        <ForegroundLayer
          cideriesScrollTo={this.scrollToCideriesSection}
          streetFoodScrollTo={this.scrollToStreetFoodSection}
          faqScrollTo={this.scrollToFAQSection}
        />
      </Fragment>
    );
  }
}

export default Ciderama;
